export const entryFlags = [
  { key: 'suspiciousTracker', text: 'Podejrzany tracker' },
  { key: 'shortHistory', text: 'Krótka historia konta' },
  { key: 'wrongValues', text: 'Błędne dane' },
  { key: 'unclear', text: 'Niejasna sytuacja' },
  { key: 'suspiciousPlayer', text: 'Podejrzany gracz' },
]
